import { CELL_WIDTHS } from '../consts.ts';

export const makeColSpan = (idx: number, span: number): `${number}%` =>
  `${CELL_WIDTHS.slice(idx, idx + span).reduce((acc, pctWidth) => acc + pctWidth, 0)}%`;
